/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionExpression } from './ConditionExpression';
import {
    ConditionExpressionFromJSON,
    ConditionExpressionFromJSONTyped,
    ConditionExpressionToJSON,
    ConditionExpressionToJSONTyped,
} from './ConditionExpression';
import type { LogicalOperatorEnum } from './LogicalOperatorEnum';
import {
    LogicalOperatorEnumFromJSON,
    LogicalOperatorEnumFromJSONTyped,
    LogicalOperatorEnumToJSON,
    LogicalOperatorEnumToJSONTyped,
} from './LogicalOperatorEnum';

/**
 * Schema-only description of a node in a condition's group tree.
 * 
 * The tree is assembled in Python by ``serialize_condition_groups`` rather than by a nested
 * serializer, so nothing about its shape can be inferred — and an un-annotated
 * SerializerMethodField generates as ``any``, which would make the whole condition tree
 * untyped in the client.
 * 
 * ``children`` is left as a plain object list on purpose: the structure is recursive, and a
 * self-referencing component buys depth the client does not use, since the UI recurses at
 * runtime. ``SchemaShapeTestCase`` holds the declared keys against a real response.
 * @export
 * @interface ConditionGroupSchema
 */
export interface ConditionGroupSchema {
    /**
     * 
     * @type {string}
     * @memberof ConditionGroupSchema
     */
    id: string;
    /**
     * 
     * @type {LogicalOperatorEnum}
     * @memberof ConditionGroupSchema
     */
    logicalOperator: LogicalOperatorEnum;
    /**
     * 
     * @type {number}
     * @memberof ConditionGroupSchema
     */
    position: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionGroupSchema
     */
    dataProviders: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConditionGroupSchema
     */
    geoArea: string | null;
    /**
     * 
     * @type {Array<ConditionExpression>}
     * @memberof ConditionGroupSchema
     */
    expressions: Array<ConditionExpression>;
    /**
     * Nested groups, each the same shape as this one.
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ConditionGroupSchema
     */
    children: Array<{ [key: string]: any; }>;
}



/**
 * Check if a given object implements the ConditionGroupSchema interface.
 */
export function instanceOfConditionGroupSchema(value: object): value is ConditionGroupSchema {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('logicalOperator' in (value as Record<string, any>)) && !('logical_operator' in (value as Record<string, any>))) || ((value as Record<string, any>)['logicalOperator'] === undefined && (value as Record<string, any>)['logical_operator'] === undefined)) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if ((!('dataProviders' in (value as Record<string, any>)) && !('data_providers' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataProviders'] === undefined && (value as Record<string, any>)['data_providers'] === undefined)) return false;
    if ((!('geoArea' in (value as Record<string, any>)) && !('geo_area' in (value as Record<string, any>))) || ((value as Record<string, any>)['geoArea'] === undefined && (value as Record<string, any>)['geo_area'] === undefined)) return false;
    if (!('expressions' in value) || value['expressions'] === undefined) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    return true;
}

export function ConditionGroupSchemaFromJSON(json: any): ConditionGroupSchema {
    return ConditionGroupSchemaFromJSONTyped(json, false);
}

export function ConditionGroupSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionGroupSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'logicalOperator': LogicalOperatorEnumFromJSON(json['logical_operator']),
        'position': json['position'],
        'dataProviders': json['data_providers'],
        'geoArea': json['geo_area'],
        'expressions': ((json['expressions'] as Array<any>).map(ConditionExpressionFromJSON)),
        'children': json['children'],
    };
}

export function ConditionGroupSchemaToJSON(json: any): ConditionGroupSchema {
    return ConditionGroupSchemaToJSONTyped(json, false);
}

export function ConditionGroupSchemaToJSONTyped(value?: ConditionGroupSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'logical_operator': LogicalOperatorEnumToJSON(value['logicalOperator']),
        'position': value['position'],
        'data_providers': value['dataProviders'],
        'geo_area': value['geoArea'],
        'expressions': ((value['expressions'] as Array<any>).map(ConditionExpressionToJSON)),
        'children': value['children'],
    };
}

